import React from 'react';
import SMDashboardView from '../shared/SMDashboardView';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMOwnerResource from 'resources/SMOwnerResource';
import moment from 'moment';
import SMConst from 'lib/SMConst';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';

class SMODashboardView extends SMDashboardView {

  requestResource(){
    SMOwnerResource.getDashboard(this.props.owner.username, {}, this.handleResponseDashboard.bind(this));

    let queries;
    queries = {
      filter: 'not_reply',
      start: moment.utc().format("YYYYMMDD"),
      per_page: 10
    };
    SMOwnerResource.searchReservations(this.props.owner.id, queries, this.handleResponsePending.bind(this));

    queries = {
      method: SMConst.ReservationMethod.Reservation,
      start: moment.utc().format("YYYYMMDD"),
      status: 'requested,confirmed',
      per_page: 3
    };
    SMOwnerResource.searchReservations(this.props.owner.id, queries, this.handleResponseRequested.bind(this));

    queries = {
      method: SMConst.ReservationMethod.Reservation,
      start: moment.utc().format("YYYYMMDD"),
      status: 'paid,postpay',
      per_page: 3
    };
    SMOwnerResource.searchReservations(this.props.owner.id, queries, this.handleResponsePaid.bind(this));
  }

  renderPendingReservations() {

    return (
      <div>
        <h2 className="dashboard-title mb20 mt50">未返信のメッセージ</h2>
        {(()=>{
          if (this.state.pendingReservations.length == 0){
            return <p className="message-supplement mb50">未返信のメッセージはありません。</p>;
          } else {
            const rows = this.state.pendingReservations.map(function(reservation, i){
              const user = reservation.user;
              const owner = reservation.owner;
              let className = 'dashboard-top__message-list';
              if (!reservation.is_read_message) {
                className += ' is-unread';
              }
              return(
                <li key={reservation.id} className={className}>
                  <div className="dashboard-top__message-list-box dashboard-top__message-icon">
                    <a href={Routes.owner_dashboard_message_path(owner.username, reservation.uid)}>
                      <img src={SMFormatHelper.userImageUrl(user, user.profile_image)} alt={user.contact_name} className="dashboard-top__main-list-icon" />
                    </a>
                  </div>
                  <div className="dashboard-top__message-list-box dashboard-top__message-name">
                    {(()=>{
                      if (!reservation.is_read_message) {
                        return <i className="fa fa-circle reserve-list__badge"></i>;
                      }
                    })()}
                    <a href={Routes.owner_dashboard_message_path(owner.username, reservation.uid)} className="link-hover-border">{user.contact_name}</a>
                  </div>
                  <div className="dashboard-top__message-list-box">
                    <p className="dashboard-top__message-content">
                      <a href={Routes.owner_dashboard_message_path(owner.username, reservation.uid)} className="link-hover-border">{reservation.message.content}</a>
                    </p>
                  </div>
                  <div className="dashboard-top__resereve-list-box dashboard-top__message-status">
                    <p className={['reserve-status-icon', SMFormatHelper.statusClassName(reservation)].join(' ')}>{SMFormatHelper.statusText(reservation)}</p>
                  </div>
                  <div className="dashboard-top__message-list-box dashboard-top__message-date">{moment(reservation.message_sent_at).format("YYYY/MM/DD HH:MM")}</div>
                </li>
              );
            });
            return (
              <ul className="dashboard-top__main-listarea">{rows}</ul>
            );
          }
        })()}
        {(()=>{
          if (this.state.hasMorePendingReservations){
            return null;
            // return (
            //   <div className="dashboard-top__buttonarea">
            //     <a href={Routes.owner_dashboard_reservations_path(this.props.owner.username, {filter: 'not_reply'})} className="button-blue maincol-buttonarea__button">もっと見る</a>
            //   </div>
            // );
          }
        })()}
      </div>
    );
  }

  renderRequestedReservations() {
    return (
      <div>
        <h2 className="dashboard-title mb20 mt50">未完了の予約リクエスト</h2>
        {(()=>{
          if (this.state.requestedReservations.length == 0){
            return <p className="message-supplement mb50">未完了の予約リクエストはありません。</p>;
          } else {
            const rows = this.state.requestedReservations.map(function(reservation, i){
              const room = reservation.room;
              const user = reservation.user;
              const owner = reservation.owner;
              return(
                <li key={reservation.id} className="dashboard-top__owner-reserve-list">
                  <div className="dashboard-top__resereve-list-box dashboard-top__owner-reserve-icon">
                    <a href={Routes.owner_dashboard_reservation_path(owner.username, reservation.uid)}>
                      <img src={SMFormatHelper.userImageUrl(user, user.profile_image)} alt={user.contact_name} className="dashboard-top__main-list-icon" />
                    </a>
                  </div>
                  <div className="dashboard-top__resereve-list-box">
                    <p className="dashboard-top__owner-reserve-date">
                      {SMRenderHelper.renderReservationIcon(reservation)}{reservation.reserved_date_text}
                    </p>
                    <p className="dashboard-top__owner-reserve-name">
                      <a href={Routes.owner_dashboard_reservation_path(owner.username, reservation.uid)} className="link-hover-border">{user.contact_name}</a>
                    </p>
                    <p className="dashboard-top__owner-reserve-price">{reservation.billing.price_both_text}</p>
                  </div>
                  <div className="dashboard-top__resereve-list-box dashboard-top__owner-reserve-status">
                    <p className={['reserve-status-icon', SMFormatHelper.statusClassName(reservation)].join(' ')}>{SMFormatHelper.statusText(reservation)}</p>
                  </div>
                  <div className="dashboard-top__resereve-list-box dashboard-top__owner-reserve-space-name">
                    <a href={Routes.owner_dashboard_reservation_path(owner.username, reservation.uid)} className="link-hover-border">{SMFormatHelper.roomName(room)}</a>
                  </div>
                </li>
              );
            });
            return(
              <ul className="dashboard-top__main-listarea">{rows}</ul>
            );
          }
        })()}
        {(()=>{
          if (this.state.hasMoreRequestedReservations){
            return (
              <div className="dashboard-top__buttonarea">
                <a href={Routes.owner_dashboard_reservations_path(this.props.owner.username, {status: 'requested, confirmed'})} className="button-blue maincol-buttonarea__button">もっと見る</a>
              </div>
            );
          }
        })()}
      </div>
    );
  }

  renderPaidReservations() {
    return (
      <div>
        <h2 className="dashboard-title mb20 mt50">予約完了</h2>
        {(()=>{
          if (this.state.paidReservations.length == 0){
            return <p className="message-supplement mb50">予約はありません。</p>;
          } else {
            const rows = this.state.paidReservations.map(function(reservation, i){
              const room = reservation.room;
              const user = reservation.user;
              const owner = reservation.owner;
              return(
                <li key={reservation.id} className="dashboard-top__owner-reserve-list dashboard-top__owner-reserve-list-done">
                  <div className="dashboard-top__resereve-list-box dashboard-top__owner-reserve-icon dashboard-top__owner-reserve-icon-done">
                    <a href={Routes.owner_dashboard_reservation_path(owner.username, reservation.uid)}>
                      <img src={SMFormatHelper.userImageUrl(user, user.profile_image)} alt={user.contact_name} className="dashboard-top__main-list-icon" />
                    </a>
                  </div>
                  <div className="dashboard-top__resereve-list-box">
                    <p className="dashboard-top__owner-reserve-date dashboard-top__owner-reserve-date-done">
                      {SMRenderHelper.renderReservationIcon(reservation)}{reservation.reserved_date_text}
                    </p>
                    <p className="dashboard-top__owner-reserve-name">
                      <a href={Routes.owner_dashboard_reservation_path(owner.username, reservation.uid)} className="link-hover-border">{user.contact_name}</a>
                    </p>
                    <p className="dashboard-top__owner-reserve-price">{reservation.billing.price_both_text}</p>
                  </div>
                  {/*<div className="dashboard-top__resereve-list-box dashboard-top__owner-reserve-status">
                    <p className={['reserve-status-icon', SMFormatHelper.statusClassName(reservation)].join(' ')}>{SMFormatHelper.statusText(reservation)}</p>
                  </div>*/}
                  <div className="dashboard-top__resereve-list-box dashboard-top__owner-reserve-space-name">
                    <a href={Routes.owner_dashboard_reservation_path(owner.username, reservation.uid)} className="link-hover-border">{SMFormatHelper.roomName(room)}</a>
                  </div>
                </li>
              );
            });
            return(
              <ul className="dashboard-top__main-listarea">{rows}</ul>
            );
          }
        })()}
        {(()=>{
          if (this.state.hasMorePaidReservations){
            return (
              <div className="dashboard-top__buttonarea">
                <a href={Routes.owner_dashboard_reservations_path(this.props.owner.username, {status: 'paid,postpay'})} className="button-blue maincol-buttonarea__button">もっと見る</a>
              </div>
            );
          }
        })()}
      </div>
    );
  }

  renderSpaceMarketAcademy() {
    return(
      <div className="dashboard-top__academy">
        <h2 className="dashboard-title mb8">スペースマーケットアカデミー</h2>
        <p className="dashboard-title__supplement mb20">
          人気ホスト・人気スペースになるコツを大公開！アクセスUPや成約UPの方法などが学べます。
        </p>
        <ul className="dashboard-top__academy-listarea">
          <li className="dashboard-top__academy-list">
            <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.OwnerHelpPageID.ManageVacantTime)} className="link-hover-border">スペースの空き状況を管理して成約率を上げる</a></p>
          </li>
          <li className="dashboard-top__academy-list">
            <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.OwnerHelpPageID.IncreaseAccess)} className="link-hover-border">アクセスが伸びるページをつくる</a></p>
          </li>
          <li className="dashboard-top__academy-list">
            <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.OwnerHelpPageID.ForCorporateUse)} className="link-hover-border">法人のニーズを捉え、法人に利用されるスペースになる</a></p>
          </li>
          <li className="dashboard-top__academy-list">
            <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.OwnerHelpPageID.SetVariousPrice)} className="link-hover-border">季節・曜日・時間ごとに価格を変動させ成約数・売上をUPさせる</a></p>
          </li>
        </ul>
        <div className="">
          <a target="_blank" href="https://help.spacemarket.com/hc/ja/categories/203845948" className="button-blue dashboard-top__academy-button">もっと見る</a>
        </div>
      </div>
    );
  }

  render() {
    const owner = this.props.owner;
    return (
      <div className="dashboard-container clearfix mb30">
        <div className="dashboard-sidecol__top">
          <img src={owner.profile_image} alt={SMFormatHelper.ownerName(owner)} className="dashboard-top__side-icon" />
          <h2 className="dashboard-top__side-name">{SMFormatHelper.ownerName(owner)}</h2>
          <ul className="dashboard-top__side-menu">
            <li className="dashboard-top__side-menu-list"><a href={Routes.owner_path(owner.username)} className="link-hover-border">プロフィールを表示</a></li>
            <li className="dashboard-top__side-menu-list"><a href={Routes.owner_dashboard_settings_account_path(owner.username)} className="link-hover-border">プロフィールを編集</a></li>
          </ul>
          {this.renderSpaceMarketAcademy()}
          <div className="dashboard-top__pr">
            <span className="dashboard-top__pr-clip"><i className="fa fa-paperclip"></i></span>
            <h2 className="dashboard-top__pr-title">{I18n.t("dashboard.label_000700")}<br />{I18n.t("dashboard.label_000701")}</h2>
            <h3 className="dashboard-top__pr-name"><a href={Routes.owner_dashboard_settings_calendar_path(this.props.owner.id)} className="link-hover-border">{I18n.t("dashboard.label_000702")}</a></h3>
            <p className="dashboard-top__pr-text">{I18n.t("dashboard.label_000703")}</p>
            <div className="ta-c">
              <a href={Routes.owner_dashboard_settings_calendar_path(this.props.owner.id)} className="button-blue pt10 pb10 w160">{I18n.t("dashboard.label_000704")}</a>
            </div>
          </div>

          <div className="dashboard-top__help">
            <h2 className="dashboard-title2 mb20">ヘルプ</h2>
            <h3 className="mb8">予約について</h3>
            <ul className="dashboard-top__help-listarea">
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.UserHelpPageID.ReservationOrInquiry)} className="link-hover-border">「問い合わせ」と「予約リクエスト」の違い</a></p>
              </li>
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.OwnerHelpPageID.RespondReservation)} className="link-hover-border">予約リクエストにはどのように対応すればよいですか？</a></p>
              </li>
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.OwnerHelpPageID.ChangeReservation)} className="link-hover-border">予約リクエストの内容を変更するにはどうすればよいですか？</a></p>
              </li>
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={Routes.how_to_host_about_index_path()} className="link-hover-border">当日の流れ</a></p>
              </li>
            </ul>
            <h3 className="mb8">決済について</h3>
            <ul className="dashboard-top__help-listarea">
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.UserHelpPageID.PaymentMethod)} className="link-hover-border">決済について詳しく知りたい</a></p>
              </li>
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.OwnerHelpPageID.GuestCancelRefund)} className="link-hover-border">ゲストからキャンセルがあった場合の払い戻し方法</a></p>
              </li>
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.OwnerHelpPageID.ChangeReservation)} className="link-hover-border">支払い完了後に利用料金が変更になったら？</a></p>
              </li>
            </ul>
            <h3 className="mb8">スペース編集について</h3>
            <ul className="dashboard-top__help-listarea">
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.OwnerHelpPageID.ReservationCalendarCooperation)} className="link-hover-border">予約カレンダーの連携機能について</a></p>
              </li>
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.OwnerHelpPageID.ChangeReservation)} className="link-hover-border">価格設定の編集はどうすればよいですか？</a></p>
              </li>
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.OwnerHelpPageID.AcceptReservationPeriod)} className="link-hover-border">予約を受け付ける期間の設定</a></p>
              </li>
            </ul>
          </div>
        </div>
        {(()=>{
          if (this.state.completeCounter < this.props.completeMaxCount) {
            return(
              <div className="dashboard-maincol__right" style={{minHeight: '30vh'}} ref="container"></div>
            );
          } else {
            return(
              <div className="dashboard-maincol__right" ref="container">
                {this.renderAnnouncements()}
                {this.renderTodoItems()}
                {this.renderPendingReservations()}
                {this.renderRequestedReservations()}
                {this.renderPaidReservations()}
              </div>
            );
          }
        })()}
      </div>
    );
  }
};

export default SMODashboardView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/SMODashboardView.jsx